import React from 'react';
import ReactDOM from 'react-dom';
import './i18n';
import './index.css';
import App from './App';
import store from './store';
import JwtDecode from 'jwt-decode';
import { softLogin } from './redux/actions/login';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import TagManager from 'react-gtm-module';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Helmet } from 'react-helmet';
import { AppConfig } from './config';

localStorage.removeItem('walletVersion');

if (process.env.REACT_APP_GTM_ID) {
  const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM_ID,
  };

  TagManager.initialize(tagManagerArgs);
}

ReactDOM.render(
  <>
    {AppConfig.identity === 'cpay' && !AppConfig?.hideLogo && (
      <Helmet>
        <title>GEME Wallet Gateway Platform</title>

        <link rel="apple-touch-icon" sizes="57x57" href="cpay-icons/favicon.ico" />
        <link rel="apple-touch-icon" sizes="60x60" href="cpay-icons/favicon.ico" />
        <link rel="apple-touch-icon" sizes="72x72" href="cpay-icons/favicon.ico" />
        <link rel="apple-touch-icon" sizes="76x76" href="cpay-icons/favicon.ico" />
        <link rel="apple-touch-icon" sizes="114x114" href="cpay-icons/mstile-150x150.png" />
        <link rel="apple-touch-icon" sizes="120x120" href="cpay-icons/mstile-150x150.png" />
        <link rel="apple-touch-icon" sizes="144x144" href="cpay-icons/mstile-150x150.png" />
        <link rel="apple-touch-icon" sizes="152x152" href="cpay-icons/mstile-150x150.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="cpay-icons/android-chrome-192x192" />
        <link rel="icon" type="image/png" sizes="192x192" href="cpay-icons/android-chrome-192x192.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="cpay-icons/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="cpay-icons/favicon-16x16.png" />
        <link rel="shortcut icon" href="cpay-icons/favicon.ico" type="image/x-icon" />
        <link rel="icon" href="cpay-icons/favicon.ico" type="image/x-icon" />

        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="msapplication-TileImage" content="cpay-icons/mstile-150x150.png" />
        <meta name="theme-color" content="#ffffff" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
        <meta name="facebook-domain-verification" content="x4w3agbj6v9fbbblha1hn8h4eii4pi" />

        <meta property="og:image:alt" content="" />
        <meta property="og:site_name" content="GEME Wallet" />
        <meta property="og:type" content="object" />

        <meta property="og:title" content="GEME Wallet Gateway Platform" />
        <meta name="twitter:title" content="GEME Wallet Gateway Platform" />
        <meta name="DC.title" content="GEME Wallet Gateway Platform" />
        <meta property="og:url" content="https://gemewallet.com/" />
        <meta name="twitter:card" content="summary_large_image" />

        <meta name="twitter:image:src" content="cpay-icons/main-page.png" />

        <meta property="og:description" content="Manage crypto payments, wallets and transactions processing." />
        <meta name="twitter:description" content="Manage crypto payments, wallets and transactions processing." />
        <meta name="description" content="Manage crypto payments, wallets and transactions processing." />

        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1920" />
        <meta property="og:image:height" content="937" />

        <link rel="manifest" href="cpay-icons/manifest.json" crossorigin="use-credentials" />
      </Helmet>
    )}

    {AppConfig.identity === 'cpay' && AppConfig?.hideLogo && (
      <Helmet>
        <title>Payblock Tech Gateway Platform</title>

        <link rel="apple-touch-icon" sizes="57x57" href="cpay-icons/favicon.ico" />
        <link rel="apple-touch-icon" sizes="60x60" href="cpay-icons/favicon.ico" />
        <link rel="apple-touch-icon" sizes="72x72" href="cpay-icons/favicon.ico" />
        <link rel="apple-touch-icon" sizes="76x76" href="cpay-icons/favicon.ico" />
        <link rel="apple-touch-icon" sizes="114x114" href="cpay-icons/mstile-150x150.png" />
        <link rel="apple-touch-icon" sizes="120x120" href="cpay-icons/mstile-150x150.png" />
        <link rel="apple-touch-icon" sizes="144x144" href="cpay-icons/mstile-150x150.png" />
        <link rel="apple-touch-icon" sizes="152x152" href="cpay-icons/mstile-150x150.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="cpay-icons/android-chrome-192x192" />
        <link rel="icon" type="image/png" sizes="192x192" href="cpay-icons/android-chrome-192x192.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="cpay-icons/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="cpay-icons/favicon-16x16.png" />
        <link rel="shortcut icon" href="cpay-icons/favicon.ico" type="image/x-icon" />
        <link rel="icon" href="cpay-icons/favicon.ico" type="image/x-icon" />

        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="msapplication-TileImage" content="payblock-icons/mstile-150x150.png" />
        <meta name="theme-color" content="#ffffff" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />

        <meta property="og:image:alt" content="Select your preferred currency from our available options." />
        <meta property="og:site_name" content="Payblock Tech" />
        <meta property="og:type" content="object" />

        <meta property="og:title" content="Payblock Tech Gateway Platform" />
        <meta name="twitter:title" content="Payblock Tech Gateway Platform" />
        <meta name="DC.title" content="Payblock Tech Gateway Platform" />
        <meta name="twitter:card" content="summary_large_image" />

        <meta name="twitter:image:src" content="payblock-icons/android-chrome-512x512.png" />

        <meta property="og:description" content="Select your preferred currency from our available options." />
        <meta name="twitter:description" content="Select your preferred currency from our available options." />
        <meta name="description" content="Select your preferred currency from our available options." />

        <meta property="og:image:type" content="payblock-icons/android-chrome-512x512.png" />
        <meta property="og:image:width" content="512" />
        <meta property="og:image:height" content="512" />

        {/*<link rel="manifest" href="nfgpay-icons/manifest.json" crossorigin="use-credentials" />*/}
        {/*<script src="/tawk_nfg.js" type="text/javascript" />*/}
      </Helmet>
    )}

    {AppConfig.identity === 'nfg' && (
      <Helmet>
        <title>Pay Your Bill with Crypto</title>

        <link rel="apple-touch-icon" sizes="57x57" href="nfgpay-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="60x60" href="nfgpay-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="72x72" href="nfgpay-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="76x76" href="nfgpay-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="114x114" href="nfgpay-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="120x120" href="nfgpay-icons/apple-icon-120x120.png" />
        <link rel="apple-touch-icon" sizes="144x144" href="nfgpay-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="152x152" href="nfgpay-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="nfgpay-icons/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="192x192" href="nfgpay-icons/android-chrome-192x192.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="nfgpay-icons/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="96x96" href="nfgpay-icons/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="nfgpay-icons/favicon-16x16.png" />
        <link rel="shortcut icon" href="nfgpay-icons/favicon.ico" type="image/x-icon" />
        <link rel="icon" href="nfgpay-icons/favicon.ico" type="image/x-icon" />

        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="msapplication-TileImage" content="nfgpay-icons/mstile-150x150.png" />
        <meta name="theme-color" content="#ffffff" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />

        <meta property="og:image:alt" content="Select your preferred currency from our available options." />
        <meta property="og:site_name" content="NFGPAY" />
        <meta property="og:type" content="object" />

        <meta property="og:title" content="Pay Your Bill with Crypto" />
        <meta name="twitter:title" content="Pay Your Bill with Crypto" />
        <meta name="DC.title" content="Pay Your Bill with Crypto" />
        <meta property="og:url" content="https://app.crypto-now.io/" />
        <meta name="twitter:card" content="summary_large_image" />

        <meta name="twitter:image:src" content="nfgpay-icons/android-chrome-512x512.png" />

        <meta property="og:description" content="Select your preferred currency from our available options." />
        <meta name="twitter:description" content="Select your preferred currency from our available options." />
        <meta name="description" content="Select your preferred currency from our available options." />

        <meta property="og:image:type" content="nfgpay-icons/android-chrome-512x512.png" />
        <meta property="og:image:width" content="512" />
        <meta property="og:image:height" content="512" />

        <link rel="manifest" href="nfgpay-icons/manifest.json" crossorigin="use-credentials" />
        {/*<script src="/tawk_nfg.js" type="text/javascript" />*/}
      </Helmet>
    )}

    {AppConfig.identity === 'finvaro' && (
      <Helmet>
        <title>Finvaro Crypto Processing</title>

        <link rel="apple-touch-icon" sizes="57x57" href="finvaro-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="60x60" href="finvaro-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="72x72" href="finvaro-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="76x76" href="finvaro-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="114x114" href="finvaro-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="120x120" href="finvaro-icons/apple-icon-120x120.png" />
        <link rel="apple-touch-icon" sizes="144x144" href="finvaro-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="152x152" href="finvaro-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="finvaro-icons/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="192x192" href="finvaro-icons/android-chrome-192x192.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="finvaro-icons/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="96x96" href="finvaro-icons/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="finvaro-icons/favicon-16x16.png" />
        <link rel="shortcut icon" href="finvaro-icons/favicon.ico" type="image/x-icon" />
        <link rel="icon" href="finvaro-icons/favicon.ico" type="image/x-icon" />

        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="msapplication-TileImage" content="finvaro-icons/mstile-150x150.png" />
        <meta name="theme-color" content="#ffffff" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />

        <meta property="og:image:alt" content="Select your preferred currency from our available options." />
        <meta property="og:site_name" content="Finvaro" />
        <meta property="og:type" content="object" />

        <meta property="og:title" content="Finvaro Crypto Processing" />
        <meta name="twitter:title" content="Finvaro Crypto Processing" />
        <meta name="DC.title" content="Finvaro Crypto Processing" />
        <meta property="og:url" content="https://crypto.finvaro.com/" />
        <meta name="twitter:card" content="summary_large_image" />

        <meta name="twitter:image:src" content="finvaro-icons/android-chrome-512x512.png" />

        <meta property="og:description" content="Select your preferred currency from our available options." />
        <meta name="twitter:description" content="Select your preferred currency from our available options." />
        <meta name="description" content="Select your preferred currency from our available options." />

        <meta property="og:image:type" content="finvaro-icons/android-chrome-512x512.png" />
        <meta property="og:image:width" content="512" />
        <meta property="og:image:height" content="512" />

        <link rel="manifest" href="finvaro-icons/manifest.json" crossorigin="use-credentials" />
      </Helmet>
    )}

    {AppConfig.identity === 'clarnium' && (
      <Helmet>
        <title>Pay Your Bill with Crypto</title>

        <link rel="apple-touch-icon" sizes="57x57" href="clarnium-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="60x60" href="clarnium-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="72x72" href="clarnium-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="76x76" href="clarnium-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="114x114" href="clarnium-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="120x120" href="clarnium-icons/apple-icon-120x120.png" />
        <link rel="apple-touch-icon" sizes="144x144" href="clarnium-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="152x152" href="clarnium-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="clarnium-icons/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="192x192" href="clarnium-icons/android-chrome-192x192.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="clarnium-icons/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="96x96" href="clarnium-icons/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="clarnium-icons/favicon-16x16.png" />
        <link rel="shortcut icon" href="clarnium-icons/favicon.ico" type="image/x-icon" />
        <link rel="icon" href="clarnium-icons/favicon.ico" type="image/x-icon" />

        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="msapplication-TileImage" content="clarnium-icons/mstile-150x150.png" />
        <meta name="theme-color" content="#ffffff" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />

        <meta property="og:image:alt" content="Select your preferred currency from our available options." />
        <meta property="og:site_name" content="Clarnium Pay" />
        <meta property="og:type" content="object" />

        <meta property="og:title" content="Pay Your Bill with Crypto" />
        <meta name="twitter:title" content="Pay Your Bill with Crypto" />
        <meta name="DC.title" content="Pay Your Bill with Crypto" />
        <meta property="og:url" content="https://app.clarnium.io/pay" />
        <meta name="twitter:card" content="summary_large_image" />

        <meta name="twitter:image:src" content="clarnium-icons/android-chrome-512x512.png" />

        <meta property="og:description" content="Select your preferred currency from our available options." />
        <meta name="twitter:description" content="Select your preferred currency from our available options." />
        <meta name="description" content="Select your preferred currency from our available options." />

        <meta property="og:image:type" content="clarnium-icons/android-chrome-512x512.png" />
        <meta property="og:image:width" content="512" />
        <meta property="og:image:height" content="512" />

        <link rel="manifest" href="clarnium-icons/manifest.json" crossorigin="use-credentials" />
      </Helmet>
    )}

    {AppConfig.identity === 'inex' && (
      <Helmet>
        <title>INEX PAY: solución de pagos con Criptomonedas</title>

        <link rel="apple-touch-icon" sizes="57x57" href="inex-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="60x60" href="inex-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="72x72" href="inex-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="76x76" href="inex-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="114x114" href="inex-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="120x120" href="inex-icons/apple-icon-120x120.png" />
        <link rel="apple-touch-icon" sizes="144x144" href="inex-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="152x152" href="inex-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="inex-icons/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="192x192" href="inex-icons/android-chrome-192x192.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="inex-icons/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="96x96" href="inex-icons/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="inex-icons/favicon-16x16.png" />
        <link rel="shortcut icon" href="inex-icons/favicon.ico" type="image/x-icon" />
        <link rel="icon" href="inex-icons/favicon.ico" type="image/x-icon" />

        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="msapplication-TileImage" content="inex-icons/mstile-150x150.png" />
        <meta name="theme-color" content="#ffffff" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />

        <meta property="og:image:alt" content="Select your preferred currency from our available options." />
        <meta property="og:site_name" content="Inex Pay" />
        <meta property="og:type" content="object" />

        <meta property="og:title" content="INEX PAY: solución de pagos con Criptomonedas" />
        <meta name="twitter:title" content="INEX PAY: solución de pagos con Criptomonedas" />
        <meta name="DC.title" content="INEX PAY: solución de pagos con Criptomonedas" />
        <meta property="og:url" content="https://inexlatampay.com/" />
        <meta name="twitter:card" content="summary_large_image" />

        <meta name="twitter:image:src" content="inex-icons/android-chrome-512x512.png" />

        <meta
          property="og:description"
          content="INEX PAY es una pasarela de pagos para negocios y empresas que desean cobrar con criptomonedas. Acepte pagos de forma rápida y segura con INEX PAY."
        />
        <meta
          name="twitter:description"
          content="INEX PAY es una pasarela de pagos para negocios y empresas que desean cobrar con criptomonedas. Acepte pagos de forma rápida y segura con INEX PAY."
        />
        <meta
          name="description"
          content="INEX PAY es una pasarela de pagos para negocios y empresas que desean cobrar con criptomonedas. Acepte pagos de forma rápida y segura con INEX PAY."
        />

        <meta property="og:image:type" content="inex-icons/android-chrome-512x512.png" />
        <meta property="og:image:width" content="512" />
        <meta property="og:image:height" content="512" />

        <link rel="manifest" href="inex-icons/manifest.json" crossorigin="use-credentials" />
      </Helmet>
    )}

    {AppConfig.identity === 'insta' && (
      <Helmet>
        <title>Pay Your Bill with Crypto</title>

        <link rel="apple-touch-icon" sizes="57x57" href="instaXchange-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="60x60" href="instaXchange-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="72x72" href="instaXchange-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="76x76" href="instaXchange-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="114x114" href="instaXchange-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="120x120" href="instaXchange-icons/apple-icon-120x120.png" />
        <link rel="apple-touch-icon" sizes="144x144" href="instaXchange-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="152x152" href="instaXchange-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="instaXchange-icons/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="192x192" href="instaXchange-icons/android-chrome-192x192.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="instaXchange-icons/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="96x96" href="instaXchange-icons/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="instaXchange-icons/favicon-16x16.png" />
        <link rel="shortcut icon" href="instaXchange-icons/favicon.ico" type="image/x-icon" />
        <link rel="icon" href="instaXchange-icons/favicon.ico" type="image/x-icon" />

        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="msapplication-TileImage" content="instaXchange-icons/mstile-150x150.png" />
        <meta name="theme-color" content="#ffffff" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />

        <meta property="og:image:alt" content="Select your preferred currency from our available options." />
        <meta property="og:site_name" content="InstaXgateaway" />
        <meta property="og:type" content="object" />

        <meta property="og:title" content="Pay Your Bill with Crypto" />
        <meta name="twitter:title" content="Pay Your Bill with Crypto" />
        <meta name="DC.title" content="Pay Your Bill with Crypto" />
        {/*<meta property="og:url" content="https://app.clarnium.io/pay" />*/}
        <meta name="twitter:card" content="summary_large_image" />

        <meta name="twitter:image:src" content="instaXchange-icons/android-chrome-512x512.png" />

        <meta property="og:description" content="Select your preferred currency from our available options." />
        <meta name="twitter:description" content="Select your preferred currency from our available options." />
        <meta name="description" content="Select your preferred currency from our available options." />

        <meta property="og:image:type" content="instaXchange-icons/android-chrome-512x512.png" />
        <meta property="og:image:width" content="512" />
        <meta property="og:image:height" content="512" />

        <link rel="manifest" href="instaXchange-icons/manifest.json" crossorigin="use-credentials" />
      </Helmet>
    )}

    {AppConfig.identity === 'coinera' && (
      <Helmet>
        <title>Finera Crypto Payment Gateway</title>

        <link rel="apple-touch-icon" sizes="57x57" href="coinera-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="60x60" href="coinera-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="72x72" href="coinera-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="76x76" href="coinera-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="114x114" href="coinera-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="120x120" href="coinera-icons/apple-icon-120x120.png" />
        <link rel="apple-touch-icon" sizes="144x144" href="coinera-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="152x152" href="coinera-icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="coinera-icons/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="192x192" href="coinera-icons/android-chrome-192x192.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="coinera-icons/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="96x96" href="coinera-icons/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="coinera-icons/favicon-16x16.png" />
        <link rel="shortcut icon" href="coinera-icons/favicon.ico" type="image/x-icon" />
        <link rel="icon" href="coinera-icons/favicon.ico" type="image/x-icon" />

        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="msapplication-TileImage" content="coinera-icons/mstile-150x150.png" />
        <meta name="theme-color" content="#ffffff" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />

        <meta property="og:image:alt" content="Select your preferred currency from our available options." />
        <meta property="og:site_name" content="Finera" />
        <meta property="og:type" content="object" />

        <meta property="og:title" content="Finera Crypto Payment Gateway" />
        <meta name="twitter:title" content="Finera Crypto Payment Gateway" />
        <meta name="DC.title" content="Finera Crypto Payment Gateway" />
        <meta name="twitter:card" content="summary_large_image" />

        <meta name="twitter:image:src" content="coinera-icons/android-chrome-512x512.png" />

        <meta property="og:description" content="Select your preferred currency from our available options." />
        <meta name="twitter:description" content="Select your preferred currency from our available options." />
        <meta name="description" content="Select your preferred currency from our available options." />

        <meta property="og:image:type" content="coinera-icons/android-chrome-512x512.png" />
        <meta property="og:image:width" content="512" />
        <meta property="og:image:height" content="512" />

        <link rel="manifest" href="coinera-icons/manifest.json" crossorigin="use-credentials" />
      </Helmet>
    )}

    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT}>
      <React.StrictMode>
        <Provider store={store}>
          {isLogedIn(store.dispatch)}
          <App />
        </Provider>
      </React.StrictMode>
    </GoogleOAuthProvider>
  </>,

  document.getElementById('root')
);

function isLogedIn(dispatch) {
  const authToken = localStorage.getItem('authToken');
  if (authToken) {
    const decodedToken = JwtDecode(authToken);
    if (Date.now() < decodedToken.exp * 1000) dispatch(softLogin(authToken));
  }
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
